import axios from 'axios';
import { API_BASE_URL } from '../config/config';

const API_URL = `${API_BASE_URL}/admin/IP/geolocation.php`;

export const GeolocationService = {
    getIPAndGeolocation: async () => {
      try {
        console.log('Fetching geolocation data...');
        const response = await axios.get(`${API_URL}?nocache=${new Date().getTime()}`);
        console.log('Raw geolocation data:', response.data);
        
        const ipAddress = response.data.geoplugin_request;
        console.log('Fetched IP address:', ipAddress);
  
        const result = {
          ip: ipAddress,
          countryCode: response.data.geoplugin_countryCode,
          countryName: response.data.geoplugin_countryName,
          city: response.data.geoplugin_city,
          currencyCode: response.data.geoplugin_currencyCode,
          currencySymbol: response.data.geoplugin_currencySymbol,
          currencyConverter: response.data.geoplugin_currencyConverter,
          ...response.data
        };
  
        console.log('Processed geolocation data:', result);
        return result;
      } catch (error) {
        console.error('Error fetching geolocation data:', error);
        if (error.response) {
          console.error('Error response:', error.response.data);
          console.error('Error status:', error.response.status);
        } else if (error.request) {
          console.error('No response received:', error.request);
        } else {
          console.error('Error message:', error.message);
        }
        throw new Error('Unable to retrieve geolocation data. Please try again later.');
      }
    }
  };
  
  